import {
    lazyRegisterBeforeUnloadHandlerProxy,
    lazyRegisterOnLoadHandlerProxy,
} from 'owa-metaos-app-bootstrap/lib/lazyAppBoot';

export const registerMetaOsAppHandlers = () => {
    lazyRegisterOnLoadHandlerProxy.importAndExecute();
    lazyRegisterBeforeUnloadHandlerProxy.importAndExecute();
};
